import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApplicationFileService } from '@features/application-file/services/application-file.service';

@Component({
  selector: 'gc-download-file-page',
  template: `
  <div class="d-flex align-items-center flex-column">
    <h1 class="yc-header mb-5 mt-5">
      <yc-i18n
        key="GLOBAL:hdrClickBelowToDownloadFile"
        defaultValue="Click the link below to download the requested file.">
      </yc-i18n>
    </h1>
    <p>
      <yc-button
        (onClick)="download()"
        [primary]="true">
        <yc-i18n
          key="GLOBAL:linkDownloadFileName"
          defaultValue="Download __fileName__"
          [context]="{
            fileName: fileName
          }"></yc-i18n>
      </yc-button>
    </p>
  </div>`,
  styles: []
})
export class DownloadFilePageComponent {
  constructor (
    private activatedRoute: ActivatedRoute,
    private applicationFileService: ApplicationFileService
  ) { }

  query = this.activatedRoute.snapshot.queryParams as {
    applicationId: string;
    applicationFormId: string;
    fileId: string;
    fileName: string;
  };

  fileName = this.query.fileName;

  async download () {
    await this.applicationFileService.openFile(
      +this.query.applicationId,
      +this.query.fileId,
      +this.query.applicationFormId
    );
  }
}
